import { Phone, MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/siteData";

export const FloatingActions = () => (
  <div className="fixed bottom-6 right-6 z-[8000] flex flex-col gap-3">
    <a
      href={BRAND.whatsapp}
      target="_blank"
      rel="noreferrer"
      data-testid="float-whatsapp"
      aria-label="Contact on WhatsApp"
      className="w-12 h-12 rounded-full bg-[#25D366] text-void flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300"
    >
      <MessageCircle size={22} />
    </a>
    <a
      href={BRAND.phoneHref}
      data-testid="float-call"
      aria-label="Call our team"
      className="w-12 h-12 rounded-full bg-gold text-void flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300"
    >
      <Phone size={20} />
    </a>
  </div>
);
